import { i18n } from '@lingui/core';
import { I18nProvider as LinguiI18nProvider } from '@lingui/react';
import React, { PropsWithChildren } from 'react';

import { ErrorView } from '../components/error-view/error-view';
import { useActivateI18n } from './hooks/use-activate-i18n';

export function I18nProvider ({ children }: PropsWithChildren<unknown>) {
    const { isError } = useActivateI18n();

    if (isError) {
        return <ErrorView />;
    }

    return (
        <LinguiI18nProvider i18n={i18n}>
            {children}
        </LinguiI18nProvider>
    );
}
